module.exports = __webpack_public_path__ + "static/media/blog-3.a9e5775c.jpg";